import { ReactNode } from 'react'
import { useLocation } from 'react-router-dom'
import { Header } from './Header'
import { Footer } from './Footer'
import { Breadcrumb } from './Breadcrumb'
import { ChatBot } from './ChatBot'

interface LayoutProps {
  children: ReactNode
}

const PAGE_BACKGROUNDS: Record<string, string> = {
  '/registration-history': '#F1F3F3',
  '/ondemand': '#F9FAFD',
}

function getPageBackground(pathname: string): string {
  if (PAGE_BACKGROUNDS[pathname]) {
    return PAGE_BACKGROUNDS[pathname]
  }
  if (/^\/session\/\d+/.test(pathname)) {
    return '#F9FAFD'
  }
  return '#ffffff'
}

export function Layout({ children }: LayoutProps) {
  const location = useLocation()
  const isDashboard = location.pathname === '/' || location.pathname === '/dashboard'
  const pageBackground = getPageBackground(location.pathname)
  
  return (  
    <>
    <div 
      className="min-h-screen flex flex-col"
      style={{ backgroundColor: pageBackground }}
    >
      {/* Content */}
      <div className="flex flex-col min-h-screen">
      <Header />
      {isDashboard ? (
        // Dashboard: full width layout for sections to extend edge-to-edge
        <div className="flex-1 w-full py-4 lg:py-8 xl:py-10">
          <main className="w-full">
            <Breadcrumb />
            {children}
          </main>
        </div>
      ) : (
        // Other pages: constrained width centered
        <div className="flex-1 w-full py-4 lg:py-6">
          <main className="max-w-[1600px] w-full mx-auto px-3 sm:px-4 lg:px-6">
            <Breadcrumb />
            {children}
          </main>
        </div>
      )}
      </div>
    </div>
    <Footer />
    <ChatBot />
    </>
  )
}
